export default class BezierPathCommand {
    static Type = {
        MOVE_TO_POINT: 0,
        ADD_LINE_TO_POINT: 1,
        ADD_QUAD_CURVE_TO_POINT: 2,
        ADD_CURVE_TO_POINT: 3,
        CLOSE_PATH: 4
    }

    constructor(type, point, controlPoint1, controlPoint2) {
        this.type = type;
        this.point = point;
        this.controlPoint1 = controlPoint1;
        this.controlPoint2 = controlPoint2;
    }
}
